import React from 'react';
import {
  createDispatchHook, createSelectorHook, createStoreHook, Provider,
} from 'react-redux';
import dodoStore from '../stores/dodo-store.js';

const DodoStoreContext = React.createContext(null);

export const DodoStoreProvider = ({ children }) => {
  return (
    <Provider store={dodoStore} context={DodoStoreContext}>
      {children}
    </Provider>
  );
};

export const useDodoStore = createStoreHook(DodoStoreContext);
export const useDodoDispatch = createDispatchHook(DodoStoreContext);
export const useDodoSelector = createSelectorHook(DodoStoreContext);
